import '../../../../assets/css/screens/admin/dashboard/booking/AdminBooking.css';
import React, { useState } from 'react';
import {
  Search, Eye, X, User, Wrench, Calendar, DollarSign,
  MapPin, Image as ImageIcon, CheckCircle, XCircle,
  ArrowRight, Clock, TrendingUp, Package, AlertCircle,
  Play, ZoomIn, ShieldAlert
} from 'lucide-react';

const ALL_BOOKINGS = [
  { id:'BK-001', customer:'Ahmad Khan',  customerPhone:'+92 300 1234567',
    provider:'Ali Electrician', providerPhone:'+92 300 1112233',
    service:'Electrical Repair', description:'Fan not working, need electrical repair in bedroom',
    date:'Mar 25, 2026', time:'10:00 AM', address:'House 12, Block F, Johar Town', city:'Lahore',
    status:'Active', amount:'Rs 2,500', priority:'Normal',
    customerMedia:[{type:'image',label:'Broken fan photo',url:'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400'},{type:'image',label:'Socket damage',url:'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?w=400'}],
    workerMedia:[] },
  { id:'BK-002', customer:'Sara Ahmed',  customerPhone:'+92 301 2223334',
    provider:'Usman Plumber',   providerPhone:'+92 301 9876543',
    service:'Plumbing Fix', description:'Leaking pipe under kitchen sink needs urgent repair',
    date:'Mar 24, 2026', time:'2:00 PM', address:'45 DHA Phase 5', city:'Karachi',
    status:'Completed', amount:'Rs 3,200', priority:'Urgent',
    customerMedia:[{type:'image',label:'Leaking pipe',url:'https://images.unsplash.com/photo-1585771724684-38269d6639fd?w=400'}],
    workerMedia:[{type:'image',label:'Pipe repaired',url:'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=400'},{type:'image',label:'Work done',url:'https://images.unsplash.com/photo-1581244277943-fe4a9c777189?w=400'}] },
  { id:'BK-003', customer:'Bilal Shah',  customerPhone:'+92 302 3334445',
    provider:'Hassan AC',       providerPhone:'+92 302 5556677',
    service:'AC Installation', description:'Install 1.5 ton split AC in living room',
    date:'Mar 23, 2026', time:'11:00 AM', address:'F-7/3, Street 14', city:'Islamabad',
    status:'Pending', amount:'Rs 4,000', priority:'Normal',
    customerMedia:[], workerMedia:[] },
  { id:'BK-004', customer:'Fatima Ali',  customerPhone:'+92 303 4445556',
    provider:'Kashif Paint',    providerPhone:'+92 303 1112222',
    service:'House Painting', description:'3 bedroom house exterior painting needed',
    date:'Mar 22, 2026', time:'9:00 AM', address:'12 Rose St', city:'Faisalabad',
    status:'Cancelled', amount:'Rs 8,500', priority:'Normal',
    customerMedia:[{type:'image',label:'Front wall',url:'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?w=400'},{type:'image',label:'Side wall',url:'https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=400'}],
    workerMedia:[] },
  { id:'BK-005', customer:'Zain Malik',  customerPhone:'+92 304 5556667',
    provider:'Kamran Clean',    providerPhone:'+92 304 7778889',
    service:'Deep Cleaning', description:'3 bedroom apartment deep cleaning before move-in',
    date:'Mar 21, 2026', time:'8:00 AM', address:'Gulberg III', city:'Lahore',
    status:'Completed', amount:'Rs 1,800', priority:'Normal',
    customerMedia:[], workerMedia:[{type:'image',label:'Kitchen cleaned',url:'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=400'},{type:'image',label:'Bathroom done',url:'https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=400'}] },
  { id:'BK-006', customer:'Ayesha Noor', customerPhone:'+92 305 6667778',
    provider:'Faisal Carp',     providerPhone:'+92 305 3334444',
    service:'Carpentry', description:'Custom wardrobe installation in master bedroom',
    date:'Mar 20, 2026', time:'3:00 PM', address:'Bahria Town', city:'Rawalpindi',
    status:'Active', amount:'Rs 5,000', priority:'Normal',
    customerMedia:[{type:'image',label:'Room measurement',url:'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400'}], workerMedia:[] },
  { id:'BK-007', customer:'Imran Siddiqui', customerPhone:'+92 306 7778889',
    provider:'Naveed Plumb',    providerPhone:'+92 306 2223334',
    service:'Pipe Leakage Fix', description:'Customer claims work was not done properly.',
    date:'Mar 18, 2026', time:'1:00 PM', address:'Clifton Block 5', city:'Karachi',
    status:'Dispute', amount:'Rs 3,500', priority:'Urgent',
    customerMedia:[{type:'image',label:'Damaged area',url:'https://images.unsplash.com/photo-1585771724684-38269d6639fd?w=400'}],
    workerMedia:[{type:'image',label:'Work proof',url:'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=400'}] },
];

const STATUS_FILTERS = ['All','Pending','Active','Completed','Cancelled','Dispute'];

const STATUS_CFG = {
  Active:    { color:'#fff', bg:'linear-gradient(135deg,#0491e1,#0672b5)', icon:<AlertCircle size={12}/>, shadow:'rgba(4,145,225,0.35)'  },
  Completed: { color:'#fff', bg:'linear-gradient(135deg,#10b981,#059669)', icon:<CheckCircle size={12}/>, shadow:'rgba(16,185,129,0.35)' },
  Pending:   { color:'#fff', bg:'linear-gradient(135deg,#f59e0b,#d97706)', icon:<Clock size={12}/>,       shadow:'rgba(245,158,11,0.35)' },
  Cancelled: { color:'#fff', bg:'linear-gradient(135deg,#ef4444,#dc2626)', icon:<XCircle size={12}/>,     shadow:'rgba(239,68,68,0.35)'  },
  Dispute:   { color:'#fff', bg:'linear-gradient(135deg,#f97316,#ea6c00)', icon:<ShieldAlert size={12}/>, shadow:'rgba(249,115,22,0.35)' },
};

const Lightbox = ({ item, onClose }) => {
  if (!item) return null;
  return (
    <div className="adm-lb" onClick={onClose}>
      <button className="adm-lb__close" onClick={onClose}><X size={20}/></button>
      <div className="adm-lb__content" onClick={e => e.stopPropagation()}>
        {item.type === 'video'
          ? <video src={item.url} controls autoPlay className="adm-lb__media"/>
          : <img src={item.url} alt={item.label} className="adm-lb__media"/>
        }
        <p className="adm-lb__label">{item.label}</p>
      </div>
    </div>
  );
};

const MediaSection = ({ items, title, icon, colorClass, onPreview }) => {
  if (!items || items.length === 0) return null;
  return (
    <div className={`bkm-media-section bkm-media-section--${colorClass}`}>
      <div className="bkm-media-section__header">
        <div className={`bkm-media-section__dot bkm-media-section__dot--${colorClass}`}/>
        {icon}
        <span>{title}</span>
        <span className={`bkm-media-section__count ${colorClass === 'worker' ? 'bkm-media-section__count--worker' : ''}`}>{items.length}</span>
      </div>
      <div className="bkm-images-row">
        {items.map((m, i) => (
          <button key={i} className={`bkm-img-thumb bkm-img-thumb--${colorClass}`} onClick={() => onPreview(m)}>
            <div className="bkm-img-thumb__img-wrap">
              <img src={m.url} alt={m.label} className="bkm-img-thumb__img"/>
              <span className="bkm-img-thumb__overlay">
                {m.type === 'video' ? <Play size={14} fill="#fff" color="#fff"/> : <ZoomIn size={14}/>}
              </span>
            </div>
            <span className="bkm-img-thumb__label">{m.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

const BookingModal = ({ b, onClose, onComplete, onCancel }) => {
  const [lightbox, setLightbox] = useState(null);
  if (!b) return null;
  const st = STATUS_CFG[b.status] || STATUS_CFG.Pending;
  return (
    <>
      <div className="bkm-overlay" onClick={onClose}>
        <div className="bkm-modal" onClick={e => e.stopPropagation()}>
          <button className="bkm-close" onClick={onClose}><X size={16}/></button>
          <div className="bkm-header">
            <span className="bkm-id">{b.id}</span>
            <span className="bkm-status-badge" style={{color:st.color,background:st.bg}}>{st.icon} {b.status}</span>
          </div>
          <div className="bkm-service-block">
            <p className="bkm-service-name">{b.service}</p>
            <p className="bkm-service-desc">{b.description}</p>
          </div>
          <div className="bkm-info-grid">
            <div className="bkm-info-cell">
              <span className="bkm-info-icon"><User size={13}/></span>
              <span className="bkm-info-lbl">Customer</span>
              <strong className="bkm-info-val">{b.customer}</strong>
              <span className="bkm-info-sub">{b.customerPhone}</span>
            </div>
            <div className="bkm-info-cell">
              <span className="bkm-info-icon bkm-info-icon--blue"><Wrench size={13}/></span>
              <span className="bkm-info-lbl">Provider</span>
              <strong className="bkm-info-val">{b.provider}</strong>
              <span className="bkm-info-sub">{b.providerPhone}</span>
            </div>
            <div className="bkm-info-cell">
              <span className="bkm-info-icon"><Calendar size={13}/></span>
              <span className="bkm-info-lbl">Date & Time</span>
              <strong className="bkm-info-val">{b.date}</strong>
              <span className="bkm-info-sub">{b.time}</span>
            </div>
            <div className="bkm-info-cell">
              <span className="bkm-info-icon"><DollarSign size={13}/></span>
              <span className="bkm-info-lbl">Amount</span>
              <strong className="bkm-info-val bkm-amount">{b.amount}</strong>
              <span className="bkm-info-sub">{b.priority}</span>
            </div>
          </div>
          <div className="bkm-address-block">
            <div className="bkm-address-icon"><MapPin size={14}/></div>
            <div>
              <span className="bkm-address-lbl">Address</span>
              <p className="bkm-address-val">{b.address}</p>
              <p className="bkm-address-city">{b.city}</p>
            </div>
          </div>
          <MediaSection items={b.customerMedia} title="Customer's Photos / Videos" icon={<User size={13}/>} colorClass="customer" onPreview={setLightbox}/>
          <MediaSection items={b.workerMedia} title="Worker's Proof" icon={<Wrench size={13}/>} colorClass="worker" onPreview={setLightbox}/>
          {(!b.customerMedia?.length && !b.workerMedia?.length) && (
            <div className="bkm-no-media"><ImageIcon size={18}/> No media attached</div>
          )}
          {(b.status === 'Active' || b.status === 'Pending') && (
            <div className="bkm-actions">
              <button className="bkm-btn bkm-btn--complete" onClick={() => onComplete(b.id)}><CheckCircle size={15}/> Mark Complete</button>
              <button className="bkm-btn bkm-btn--cancel"   onClick={() => onCancel(b.id)}><XCircle size={15}/> Cancel Booking</button>
            </div>
          )}
          {b.status === 'Dispute' && (
            <div className="bkm-status-note bkm-status-note--dispute">🛡️ Dispute raised — under admin review</div>
          )}
        </div>
      </div>
      <Lightbox item={lightbox} onClose={() => setLightbox(null)}/>
    </>
  );
};

const AdminBookings = () => {
  const [bookings,     setBookings]  = useState(ALL_BOOKINGS);
  const [activeFilter, setActive]    = useState('All');
  const [search,       setSearch]    = useState('');
  const [selected,     setSelected]  = useState(null);

  const counts = {
    total:     bookings.length,
    active:    bookings.filter(b=>b.status==='Active').length,
    completed: bookings.filter(b=>b.status==='Completed').length,
    cancelled: bookings.filter(b=>b.status==='Cancelled').length,
  };

  const STAT_CARDS = [
    { label:'Total Bookings', value:counts.total,     bg:'linear-gradient(135deg,#0491e1,#0672b5)', shadow:'rgba(4,145,225,0.38)',  icon:<Package size={22}/>     },
    { label:'Active',         value:counts.active,    bg:'linear-gradient(135deg,#0491e1,#0672b5)', shadow:'rgba(4,145,225,0.38)', icon:<TrendingUp size={22}/>  },
    { label:'Completed',      value:counts.completed, bg:'linear-gradient(135deg,#0491e1,#0672b5)', shadow:'rgba(4,145,225,0.38)', icon:<CheckCircle size={22}/> },
    { label:'Cancelled',      value:counts.cancelled, bg:'linear-gradient(135deg,#0491e1,#0672b5)', shadow:'rgba(4,145,225,0.38)',  icon:<XCircle size={22}/>     },
  ];

  const filtered = bookings.filter(b => {
    const matchF = activeFilter==='All' || b.status===activeFilter;
    const q = search.toLowerCase();
    return matchF && (b.id.toLowerCase().includes(q)||b.customer.toLowerCase().includes(q)||b.provider.toLowerCase().includes(q)||b.service.toLowerCase().includes(q));
  });

  const handleComplete = (id) => { setBookings(prev => prev.map(b => b.id===id ? {...b,status:'Completed'} : b)); setSelected(prev => prev ? {...prev,status:'Completed'} : null); };
  const handleCancel   = (id) => { setBookings(prev => prev.map(b => b.id===id ? {...b,status:'Cancelled'} : b)); setSelected(prev => prev ? {...prev,status:'Cancelled'} : null); };

  return (
    <div className="bk-page">
      <div>
        <h2 className="bk-page-title">Bookings</h2>
        <p className="bk-page-sub">Manage and monitor all service bookings</p>
      </div>
      <div className="bk-stats">
        {STAT_CARDS.map((s,i) => (
          <div key={s.label} className="bk-stat" style={{background:s.bg,'--bk-shadow':s.shadow,animationDelay:i*0.08+'s'}}>
            <div className="bk-stat__circle"/>
            <div className="bk-stat__top"><div className="bk-stat__icon">{s.icon}</div></div>
            <div className="bk-stat__value">{s.value}</div>
            <div className="bk-stat__label">{s.label}</div>
          </div>
        ))}
      </div>
      <div className="bk-page-header">
        <div className="bk-tabs">
          {STATUS_FILTERS.map(f=>(
            <button key={f} className={'bk-tab'+(activeFilter===f?' bk-tab--active':'')} onClick={()=>setActive(f)}>{f}</button>
          ))}
        </div>
        <div className="bk-search">
          <Search size={15}/>
          <input type="text" placeholder="Search bookings..." value={search} onChange={e=>setSearch(e.target.value)}/>
        </div>
      </div>
      <div className="bk-table-wrap">
        <table className="bk-table">
          <thead>
            <tr><th>ID</th><th>Customer</th><th>Provider</th><th>Service</th><th>Date</th><th>Status</th><th>Amount</th><th>View</th></tr>
          </thead>
          <tbody>
            {filtered.map((b,i) => {
              const st = STATUS_CFG[b.status]||STATUS_CFG.Pending;
              return (
                <tr key={b.id} style={{animationDelay:i*0.05+'s'}}>
                  <td className="bk-td-id">{b.id}</td>
                  <td><strong>{b.customer}</strong></td>
                  <td className="bk-td-muted">{b.provider}</td>
                  <td>{b.service}</td>
                  <td className="bk-td-muted">{b.date}</td>
                  <td><span className="bk-badge" style={{color:st.color,background:st.bg}}>{st.icon} {b.status}</span></td>
                  <td className="bk-td-amount">{b.amount}</td>
                  <td><button className="bk-view-btn" onClick={()=>setSelected(b)}><Eye size={16}/></button></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="bk-mob-cards">
        {filtered.map((b,i) => {
          const st = STATUS_CFG[b.status]||STATUS_CFG.Pending;
          return (
            <div key={b.id} className="bk-mob-card" style={{animationDelay:i*0.06+'s'}} onClick={()=>setSelected(b)}>
              <div className="bk-mob-top">
                <span className="bk-td-id">{b.id}</span>
                <span className="bk-badge" style={{color:st.color,background:st.bg}}>{st.icon} {b.status}</span>
              </div>
              <p className="bk-mob-service">{b.service}</p>
              <div className="bk-mob-route">
                <span>{b.customer}</span><ArrowRight size={13} className="bk-mob-arrow"/><span>{b.provider}</span>
              </div>
              <div className="bk-mob-footer">
                <span className="bk-mob-date"><Calendar size={12}/> {b.date}</span>
                <span className="bk-mob-amount">{b.amount}</span>
              </div>
            </div>
          );
        })}
      </div>
      {selected && <BookingModal b={selected} onClose={() => setSelected(null)} onComplete={handleComplete} onCancel={handleCancel}/>}
    </div>
  );
};

export default AdminBookings;